const mutations = {
	setFlag: ( state, { flag, is, } ) => {
		state[ flag ] = !!is;
	},
	editOutcome: ( state, { outcomeId, } ) => {
		state.editingOutcomeId = outcomeId;
	},
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/meetingAgenda/mutations.js